// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vueMoment from 'vue-moment'
import Paginate from 'vuejs-paginate'
import {Slide} from 'vue-burger-menu'
import store from '@/store'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(vueMoment)
Vue.component('paginate', Paginate)
Vue.component('slide', Slide)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  components: { App },
  template: '<App/>',
  store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js